export const addresses = {
  alphatoken: "0xd5EF5438928E81A43a49c95c1b875aAe832C980F",
};
